import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Spin } from 'antd';
import styles from '../../styles/reportDetail.module.less';

interface Tab2ContentProps {
  studyInstanceUid: string;
  currentHost: string;
  city: string | null; // 允许 null 以表示未加载
  province: string | null;
  modality_code?: string;
}

const Tab2Content: React.FC<Tab2ContentProps> = ({
  studyInstanceUid,
  currentHost,
  city,
  province,
  modality_code,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // 使用 useMemo 计算 iframe 的 src，优化性能
  const iframeSrc = useMemo(() => {
    if (city === null || province === null) {
      return null; // 未加载完成时不生成 src
    }
    const uidArr = studyInstanceUid.split(';');
    let uidStr = '';
    uidArr.map(item => {
      uidStr += '&StudyInstanceUIDs=' + item;
    });
    let url = '';
    if (modality_code === 'SM') {
      url =
        `${currentHost}/microscopy?type=yyx.${province || '未知'}${city || '未知'}&` +
        uidStr.slice(1);
    } else {
      url =
        `${currentHost}/viewer?type=yyx.${province || '未知'}${city || '未知'}&` + uidStr.slice(1);
    }
    return url;
  }, [studyInstanceUid, currentHost, city, province]);

  useEffect(() => {
    if (iframeSrc && iframeRef.current) {
      console.log('生成的iframe src:', iframeSrc);
      iframeRef.current.src = iframeSrc;
    }
  }, [iframeSrc, studyInstanceUid]);

  return (
    <div className={styles.viewerBoxMain}>
      {!studyInstanceUid ? (
        <p style={{ color: '#666', fontSize: '16px', textAlign: 'left', paddingTop: '20px' }}>
          当前检查无图像
        </p>
      ) : city === null || province === null ? (
        <Spin
          tip="加载位置信息中..."
          style={{ paddingTop: '50px' }}
        >
          <p style={{ color: '#666', fontSize: '16px', textAlign: 'left' }}></p>
        </Spin>
      ) : (
        <iframe
          ref={iframeRef}
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default Tab2Content;
